import React from 'react'

export const ButtonsComp = (props) => {
  const { buttons = [], addEditFlag } = props
  return (
    <div className="buttons-comp-wrapper">
      {buttons.length
        ? buttons.map((b, index) => (
            <ButtonComp
              key={`button_id_${typeof b.id !== 'undefined' ? b.id : index}`}
              {...b}
              addEditFlag={addEditFlag}
            />
          ))
        : ''}
    </div>
  )
}

export const ButtonComp = (props) => {
  let {
    buttonWrapperClass = '',
    iconClass = '',
    buttonClick = '',
    iconActiveClass = '',
    btnStyle = {},
    ariaDescribedref=null,
    ariaPressed=""
  } = props
  const buttonStyle = {}
  if (buttonClick) {
    buttonStyle.onClick = () => buttonClick(props)
    buttonStyle.onKeyDown = (e) => {
      if (e.keyCode === 13 || e.keyCode === 32) {
        buttonClick(props)
      }
    }
  }
  if (iconActiveClass !== '' && buttonWrapperClass) {
    iconClass = iconActiveClass
  }

  return (
    <div
      tabIndex={0}
      className={`button-comp ${buttonWrapperClass}`}
      data-testid="button-comp-test-id"
      {...buttonStyle}
      style={iconClass ? { ...btnStyle } : { ...btnStyle, paddingLeft: '10px' }}
      role="button"
      aria-describedby={ariaDescribedref}
      aria-pressed= {ariaPressed}
    >
      {iconClass && <div className={`button-comp-icon ${iconClass}`} />}
      <div className="button-comp-label" data-testid="button-comp-label">
        {props.label}
      </div>
    </div>
  )
}

export const TypeFaceText = () => {
  return <span className="typefacetext" data-testid ="typefacetext">*</span>
}

export default {
  ButtonsComp,
  ButtonComp,
  TypeFaceText,
}
